export const DEFAULT_COLLECTIONS_STATE = {
  loading: false,
  collections: [],
};
